export const AppName = "ASAP UAE";

// Public site origin. Single source for canonical URLs, Open Graph tags, and
// structured-data @id values so every page emits an identical host.
export const AppUrl = "https://www.asapuae.com";

export const tokenBeaer = "Token"

// Google Maps JavaScript API key. It ships in the client bundle by design, so it
// MUST be restricted by HTTP referrer in the Google Cloud console.
export const GoogleMapsKey =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  "AIzaSyCXFj0R51PJgrNcDWXGvfs0tZB0pSRDFLE";

// Google Business Profile place id. A public identifier, not a secret, so it is
// safe to ship in the bundle. Used to read the live reviews and to build the
// "View more on Google" link.
export const GooglePlaceId =
  process.env.REACT_APP_GOOGLE_PLACE_ID || "ChIJIX3f8dW3pzsRtt1-c3Dguic";
// ChIJf-OIfkVfXz4RvEqpkg2o09A (uae) | ChIJIX3f8dW3pzsRtt1-c3Dguic (ind)
export const GoogleReviewsUrl = `https://search.google.com/local/reviews?placeid=${GooglePlaceId}`;